import React from "react";
import { cn } from "../lib/helpers";
import { Link } from "gatsby";

import * as styles from "../styles/components/links.module.css";

const Links = (props) => {

  const {
    button,
    link,
    dark
  } = props;

  return (
    <div className={cn(styles.root, dark && styles.dark)}>
      {button && button.url && 
        <div className={styles.linkItem}>
          {button.blank
            ? <a href={button.url} className={cn("btn", button.secondaryButton && "secondary")} target="_blank" rel="noreferrer">
                {button.text}
              </a>
            : <Link to={button.url} className={cn("btn", button.secondaryButton && "secondary")}>
                {button.text}
              </Link>
          }
        </div>
      }
      {link && link.url && 
        <div className={styles.linkItem}>
          {link.blank
            ? <a href={link.url} className="btn secondary" target="_blank" rel="noreferrer">{link.text}</a>
            : <Link to={link.url} className="btn secondary">{link.text}</Link>
          }
        </div>
      }
    </div>
  );
}

export default Links;
